(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-shop-trigger]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      dialog?.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-quick-shop-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('dialog.card-product__quick-shop-dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
